import VizaroIcon from '@/component/common/VizaroIcon';

const GameOverDefaultScreen = () => {
  return (
    <div className="h-full w-full bg-[#12121273] flex justify-center items-center">
      <div className="bg-[#ffffff] border-2 px-6 py-4 rounded-md flex justify-center items-center gap-4 flex-col">
        <VizaroIcon />
        <div className="text-xl font-bold text-center text-gray-700">
          This AR Experience is Over
        </div>
      </div>
    </div>
  );
};

export default GameOverDefaultScreen;
